//Converts a date in the format YYYY-MM-DD to MM/DD/YY
//Example: "2018-11-01" returns "11/1/18"
export default function formattedDate(value) {
	let dateArr;
	let day;
	let month;
	let year;
	let ret;

	if (value) {
		dateArr = value.split("-");
		year = dateArr[0];
		month = dateArr[1];
		day = dateArr[2];
		ret = month && day && year ? `${month}/${day}/${year}` : "";
	}
	return ret ? ret : "";
}
